<ng-template #template>
  <div [style]="style">
    <ng-template [component]="{ name: componentName, data: componentData }"></ng-template>
  </div>
</ng-template>